import React from 'react';
import {Grid, Typography} from '@material-ui/core';
import {PageTitle, ProgramTable} from '@queensland-running/qr-components';
import {useTranslation} from "react-i18next";
import {usePrograms} from "@components";

export const ProgramPage = () => {
    const {t} = useTranslation('common')
    const { programs } = usePrograms()

    return (
        <>
            <PageTitle title={t('app.routes.programs')}/>
            <Grid container spacing={3}>
                {
                    programs.map(({name, description, program}) => (
                        <Grid item xs={12} md={(name === 'All Schools Championships' || name === 'Championship') ? 12 : 6} key={name}>
                            <Typography variant="h5" color={'secondary'}>
                                {name.replace('All Schools Championships', 'School Prep Meet')}
                            </Typography>
                            { description && <Typography>{description}</Typography>}
                            <ProgramTable programItems={program}/>
                        </Grid>
                    ))
                }
            </Grid>
        </>
    );
};
